<template>
  <div class="orderDetails" v-if="orderDetails">
    <div class="main">
      <div class="center-panel">
        <div class="center-container">
          <div class="center-header">
            <div class="rp-header">
              <div v-if="orderDetails">Order {{orderDetails.order_name}}</div>
              <div class="arrows" v-if="pageCount > 0">
                <img
                  @click="prevPage"
                  class="arrow-icon"
                  style="margin-right:30px"
                  src="../../src/assets/images/icons/0828-chevron-left.svg"
                />
                <img
                  class="arrow-icon"
                  @click="nextPage"
                  src="../../src/assets/images/icons/0829-chevron-right.svg"
                />
              </div>
            </div>
            <h2
              v-if="orderDetails"
              :class="{'approved': (orderDetails.order_status !== 'Approved'), 'revised': (orderDetails.order_status === 'Revised') }"
            >STATUS: {{status.toUpperCase()}}</h2>
            <div
              v-if="orderDetails.order_status != 'Revised'"
              :class="{'button-container': true, 'disabled': orderDetails.order_status != 'Approved'}"
            >
              <button
                @click='openShippingModal("Shipped")'
                style="margin-right: 13px"
                :disabled="orderDetails.order_status != 'Approved' || approver"
                :class="{'activeShip': (orderDetails.shipping_status == 'Shipped') && !approver, 'active': (orderDetails.shipping_status === 'Shipped') && approver}"
              >SHIPPED</button>
              <button
                @click='openShippingModal("Returned")'
                style="margin-right: 13px"
                :disabled="orderDetails.order_status != 'Approved' || approver"
                :class="{'activeShip': (orderDetails.shipping_status == 'Returned') && !approver, 'active': (orderDetails.shipping_status === 'Returned') && approver}"
              >RETURNED</button>
              <button
                v-if="admin"
                @click='openShippingModal("Reminder")'
                style="margin-right: 13px"
                :disabled="orderDetails.order_status != 'Approved' || approver"
                :class="{'activeShip': (orderDetails.shipping_status == 'Return Remind') && !approver, 'active': (orderDetails.shipping_status === 'Return Remind') && approver}"
              >REMINDER</button>
              <button
                :disabled="orderDetails.order_status != 'Approved' || approver"
                @click='openShippingModal("Overdue")'
                style="margin-right: 13px"
                :class="{'activeShip': (orderDetails.shipping_status == 'Overdue') && !approver, 'active': (orderDetails.shipping_status === 'Overdue') && approver}"
              >OVERDUE</button>
              <button
              v-if="admin"
                @click='openShippingModal("Delivered")'
                :disabled="orderDetails.order_status != 'Approved' || approver"
                :class="{'activeShip': (orderDetails.shipping_status == 'Delivered') && !approver, 'active': (orderDetails.shipping_status === 'Delivered') && approver}"
              >DELIVERED</button>
            </div>
            <h5>Unfulfilled ({{orderDetails.quantity}})</h5>
          </div>
          <div v-if="orderDetails">
            <div
              v-for="order in orderDetails.order_items.slice(indexStart, indexEnd)"
              :key="order.sku"
              class="order-container"
            >
              <div class="order-left">
                <div class="img-container">
                  <img class="order-img" :src="order.image" />
                </div>
                <div class="info-container">
                  <p class="order-large">{{order.title}}</p>
                  <p class="order-small">SKU: {{order.sku}}</p>
                  <!-- <p class="order-small">{{order.orderName2}}</p> -->
                  <div class="date-container">
                    <div class="date-label">
                      <div class="dates" style="font-weight: normal; margin-bottom: 5px;">
                        From:
                        <span style="margin-left: 5px;">{{order.from_date}}</span>
                      </div>
                      <div class="dates" style="font-weight: normal">
                        To:
                        <span style="margin-left: 20px;">{{order.to_date}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="order-right">
                <div class="cost">{{order.price | currency }} x {{order.quantity}}</div>
                <div class="total">{{order.total | currency }}</div>
              </div>
            </div>
          </div>
          <div class="button-container-bottom">
            <button
              style="margin-right: 13px;"
              v-if="orderDetails.order_status !='Pending' && !approver"
              @click='openStatusModal("Pending")'
              :class="{'approved-btn': true, 'active': (orderDetails.order_status === 'Pending')}"
            >PENDING</button>
            <button
              v-if="orderDetails.order_status === 'Pending' && !approver"
              style="margin-right: 13px;"
              :class="{'approved-btn': true, 'active': (orderDetails.order_status === 'Pending')}"
            >PENDING</button>
            <button
              style="margin-right: 13px;"
              v-if="orderDetails.order_status !='Approved'"
              @click='openStatusModal("Approved")'
              :disabled="orderDetails.order_status === 'Revised'"
              :class="{'approved-btn': true, 'active': (orderDetails.order_status === 'Approved')}"
            >APPROVED</button>
            <button
              v-if="orderDetails.order_status === 'Approved'"
              style="margin-right: 13px;"
              :class="{'approved-btn': true, 'active': (orderDetails.order_status === 'Approved')}"
            >APPROVED</button>
            <button
              @click='openStatusModal("Edit")'
              v-if="orderDetails.order_status != 'Revised'"
              :disabled="orderDetails.order_status === 'Approved' || orderDetails.order_status === 'Revised'"
              :class="{'revised-btn': true}"
            >EDIT</button>
            <button
              v-if="orderDetails.order_status === 'Revised'"
              :class="{'revised-btn': true}" disabled="true"
            >EDIT</button>
          </div>
        </div>
      </div>
      <div class="right-panel" v-if="orderDetails">
        <div class="rp-container" v-if="admin">
          <h3>Approver</h3>
          <p>{{orderDetails.approver_name}}</p>
        </div>
        <div class="rp-container">
          <h3>Customer</h3>
          <p>{{orderDetails.customer_name}}</p>
          <p>{{orderDetails.customer_orders_count}} order(s)</p>
        </div>
        <div class="rp-container">
          <h3>Contact Info</h3>
          <p>{{orderDetails.customer_email}}</p>
        </div>
        <div class="rp-container">
          <h3>Shipping Address</h3>
          <p>{{orderDetails.shipping.name}}</p>
          <p>{{orderDetails.shipping.address}}</p>
          <p>{{orderDetails.shipping.city}}, {{orderDetails.shipping.state}} {{orderDetails.shipping.zip}}</p>
          <p>{{orderDetails.shipping.country}}</p>
          <a @click="viewMap(orderDetails.order_status_url)" class="view-map">View map</a>
        </div>
        <div class="rp-container">
          <h3>Billing Address</h3>
          <p v-if="orderDetails.match">Same as shipping address</p>
          <p v-if="!orderDetails.match">{{orderDetails.billing.name}}</p>
          <p v-if="!orderDetails.match">{{orderDetails.billing.address}}</p>
          <p
            v-if="!orderDetails.match"
          >{{orderDetails.billing.city}}, {{orderDetails.billing.state}} {{orderDetails.billing.zip}}</p>
          <p v-if="!orderDetails.match">{{orderDetails.billing.country}}</p>
        </div>
        <div class="rp-container-last">
          <h3>Delivery Date</h3>
          <p>{{orderDetails.delivery_date}}</p>
        </div>
      </div>
    </div>
    <modal class="modal-screens" v-show="isModalOpen">
      <template v-slot:header>
        <div>{{modalHeader}}</div>
      </template>
      <template v-slot:body-overflow class="body">
        <div v-if="modalType == 'confirmShippingStatus'" class="app-modal">
          <h3
            v-if="tempShippingStatus != 'Shipped' && tempShippingStatus != 'Reminder'"
          >Would you like to set the shipping status to {{tempShippingStatus}}?</h3>
          <h3 v-if="tempShippingStatus == 'Reminder'">
            Would you like to send a return reminder email?
          </h3>
          <div class="app-modal" v-if="tempShippingStatus == 'Shipped'">
            <input
              style="margin-bottom: 20px"
              placeholder="Tracking number"
              v-model="trackingNumber"
            />
            <div
              class="tracking-inputs"
              v-for="trackingInput in additionalTracking"
              :key="trackingInput.id"
            >
              <input placeholder="Tracking number" v-model="trackingInput.trackingNumber" />
              <img
                @click="removeTracking(trackingInput.id)"
                class="circle-icon"
                src="../../src/assets/images/icons/0861-circle-minus.svg"
              />
            </div>
            <div class="uploaded-file" style="padding-top:10px;">
              <img
                style="height: 18px; cursor: pointer;"
                src="../../src/assets/images/icons/0860-plus-circle-blue.svg"
                @click="addTracking('')"
              />
              <div @click="addTracking('')" style="margin-left: 10px; cursor: pointer;">ADD MORE</div>
            </div>
            <div class="upload-container">
              <img style="height:25px;" src="../../src/assets/images/icons/0192-folder-upload.svg" />
              <input
                class="file-input"
                type="file"
                id="file"
                ref="file"
                accept=".zip, .pdf"
                v-on:change="handleFileUpload()"
              />
            </div>
            <div class="uploaded-file" v-if="file">
              {{file.name}}
              <img
                style="padding-left: 10px; cursor: pointer; height: 18px;"
                class="delete"
                @click="removeFile()"
                src="../../src/assets/images/icons/0405-delete.svg"
              />
            </div>
          </div>
        </div>
        <div v-if="modalType == 'confirmOrderStatus'" class="app-modal">
          <h3 v-if="tempOrderStatus == 'Approved'">Would you like to approve this order?</h3>
          <h3 v-if="tempOrderStatus == 'Pending'">Are you sure you want to update the status of this order to pending?.</h3>
          <div class="edit-container" v-if="tempOrderStatus == 'Edit'">
          <div class="flex-container">
            <h3 style="margin-right: 20px !important">Did this order have too many items requested?</h3>
            <div class="boolean-container">
              <button
                :class="{'boolean-btn-yes': true, 'active': (requested == yes)}"
                @click="updateRequested(yes)"
              >YES</button>
              <button
                :class="{'boolean-btn-no': true, 'active': (requested == no)}"
                @click="updateRequested(no)"
              >NO</button>
            </div>
          </div>
          <h3 style="margin-bottom: 20px;">Which items would you like removed?</h3>
          <input style="width: 96%; margin-bottom: 20px;" placeholder="Type items here" v-model="revisedMessage" />
          <div class="flex-container">
            <h3 style="max-width: 50%"
            >Was the order placed too close in advance to the event date?</h3>
            <div class="boolean-container">
              <button
                :class="{'boolean-btn-yes': true, 'active': (proximity == yes)}"
                @click="updateProximity(yes)"
              >YES</button>
              <button
                :class="{'boolean-btn-no': true, 'active': (proximity == no)}"
                @click="updateProximity(no)"
              >NO</button>
            </div>
          </div>
          <div class="flex-container">
            <h3>Is this order still needed?</h3>
            <div class="boolean-container">
              <button
                :class="{'boolean-btn-yes': true, 'active': (needed == yes)}"
                @click="updateNeeded(yes)"
              >YES</button>
              <button
                :class="{'boolean-btn-no': true, 'active': (needed == no)}"
                @click="updateNeeded(no)"
              >NO</button>
            </div>
          </div>
          <h3 style="margin-bottom: 20px;">Additional Comments?</h3>
          <textarea v-model=addComments placeholder= 'Additional comments'></textarea>
          </div>
        </div>
        </template>
      <template v-slot:footer>
        <button :disabled="(tempOrderStatus == 'Edit' && !editValid) || (tempShippingStatus =='Shipped' && !shippingValid)" @click="commit" style="margin-right: 13px;">CONFIRM</button>
        <button @click="closeModal">CANCEL</button>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  GET_ORDER_DETAILS,
  SET_ORDER_STATUS,
  SET_SHIPPING_STATUS
} from "@/store/actions.type";
import Modal from "@/components/Modal.vue";

export default {
  name: "orderDetails",
  components: {
    Modal
  },
  props: {
    parentData: Array
  },
  data() {
    return {
      orderNo: null,
      orderNoDisplay: "Order " + this.$route.params.order,
      reviewed: "(" + 4 + ")",
      orderStatus: null,
      shippingStatus: null,
      admin: this.$store.getters.isAdmin,
      pageNumber: 0,
      error: "",
      isModalOpen: false,
      modalHeader: "",
      modalType: "",
      trackingNumber: "",
      tempShippingStatus: "",
      indexStart: 0,
      indexEnd: 3,
      tempOrderStatus: "",
      file: null,
      additionalTracking: [],
      trackingNumbers: [],
      requested: null,
      proximity: null,
      needed: null,
      yes: 'Yes',
      no: 'No',
      revisedMessage: null,
      addComments: null
    };
  },
  methods: {
    openShippingModal(status) {
        this.modalType = "confirmShippingStatus";
        this.isModalOpen = true;
        this.modalHeader = "Shipping Info";
        this.tempShippingStatus = status;
        if(this.orderDetails.tracking_numbers){
          if(this.orderDetails.tracking_numbers.length > 1){
            this.trackingNumber = this.orderDetails.tracking_numbers[0];
            for(let i = 1; i < this.orderDetails.tracking_numbers.length; i++){
              this.addTracking(this.orderDetails.tracking_numbers[i]);
            }
          }
          else{
            this.trackingNumber = this.orderDetails.tracking_numbers[0];
          }
        }
    },
    openStatusModal(status) {
      if (status == "Edit") {
        this.modalHeader = "Confirm Edited Order";
      } else if(status == "Approved") {
        this.modalHeader = "Confirm Approved Order";
      }
      else if(status == "Pending") {
        this.modalHeader = "Confirm Pending Order"
      }
      this.isModalOpen = true;
      this.modalType = "confirmOrderStatus";
      this.tempOrderStatus = status;
    },
    setOrderStatus() {
      const loader = this.$loading.show();
      let status = this.orderStatus;
      switch (status) {
        case "Pending":
          status = 0;
          break;
        case "Approved":
          status = 1;
          break;
        case "Edit":
          status = 2;
          break;
        default:
          status = 0;
          break;
      }
      this.$store
        .dispatch(SET_ORDER_STATUS, {
          orderId: this.orderDetails.order_id,
          status: status,
          revisedMessage: this.revisedMessage,
          tooManyItems: this.requested,
          tooCloseToEvent: this.proximity,
          stillNeeded: this.needed,
          additionalComments: this.addComments
        })
        .then(() => {
          loader.hide();
          this.isModalOpen = false;
          this.$notify({
            text: "Order Status Updated",
            classes: "vue-notification",
            position: "top center",
            type: "success"
          });
          this.$emit("reviewed");
          this.getOrderDetails();
        })
        .catch(err => {
          this.$notify({
            text: "Order Status Update Failed",
            classes: "vue-notification",
            position: "top center",
            type: "error"
          });
          this.error = err;
          loader.hide();
        });
    },
    setShippingStatus() {
    const loader = this.$loading.show();
      let status = this.shippingStatus;
      let fileId = "";
      switch (status) {
        case "Shipped":
          if (this.additionalTracking.length > 0) {
            for (let i = 0; i < this.additionalTracking.length; i++) {
              this.trackingNumbers.push(
                this.additionalTracking[i].trackingNumber
              );
            }
            this.trackingNumbers.unshift(this.trackingNumber);
          } else {
            this.trackingNumbers = [this.trackingNumber];
          }
          this.trackingNumbers.map(String);
          if (this.file) {
            if(this.file.type === 'application/zip'){
               fileId = this.orderDetails.order_id.toString() + ".zip";
            }
            else{
              fileId = this.orderDetails.order_id.toString() + ".pdf";
            }
          }
          status = 1;
          break;
        case "Returned":
          status = 2;
          break;
        case "Overdue":
          status = 3;
          break;
        case "Reminder":
          status = 5;
          break;
        case "Delivered":
          status = 4;
          break;
        default:
          status = 0;
          break;
      }
      this.$store
        .dispatch(SET_SHIPPING_STATUS, {
          orderId: this.orderDetails.order_id,
          status: status,
          trackingNumbers: this.trackingNumbers,
          fileName: fileId,
          file: this.file
        })
        .then(() => {
          loader.hide();
          this.isModalOpen = false;
          this.$notify({
            text: "Shipping Status Updated",
            classes: "vue-notification",
            position: "top center",
            type: "success"
          });
          this.trackingNumbers = [];
          this.trackingNumber = "";
          this.additionalTracking = [];
          this.file =  null;
          this.getOrderDetails();
        })
        .catch(err => {
          this.$notify({
            text: "Shipping Status Update Failed",
            classes: "vue-notification",
            position: "top center",
            type: "error"
          });
          this.error = err;
          loader.hide();
        });
    },
    viewMap(url) {
      window.open(url);
    },
    nextPage() {
      if (this.pageNumber < this.pageCount && this.pageNumber != this.pageCount){
        this.pageNumber += 1;
        this.indexStart +=3;
        this.indexEnd +=3;
      }
    },
    prevPage() {
      if (this.pageCount >= this.pageNumber && this.pageNumber !== 0){
        this.pageNumber -= 1;
        this.indexStart -=3;
        this.indexEnd -=3;
      }
    },
    closeModal() {
      this.additionalTracking = [];
      this.isModalOpen = false;
      this.trackingNumber = "";
      this.needed = null
      this.proximity = null
      this.requested = null
      this.revisedMessage = "";
      this.addComments = "";
      this.file = null;
    },
    commit() {
      if (this.modalType == "confirmOrderStatus") {
        this.orderStatus = this.tempOrderStatus;
        this.setOrderStatus();
      } else if (this.modalType == "confirmShippingStatus") {
        this.shippingStatus = this.tempShippingStatus;
        this.setShippingStatus();
      } else {
        this.closeModal();
      }
    },
    getOrderDetails() {
      const loader = this.$loading.show();
      this.$store
        .dispatch(GET_ORDER_DETAILS, this.orderNo)
        .catch(err => {
          this.error = err;
        })
        .finally(() => {
          this.$emit("clearStatusFilter");
          loader.hide();
        });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    removeFile() {
      this.file = null;
      document.getElementById("file").value = null;
    },
    addTracking(number) {
      this.additionalTracking.push({
        trackingNumber: number,
        id: this.additionalTracking.length
      });
    },
    removeTracking(id) {
      for (var i = 0; i < this.additionalTracking.length; i++) {
        if (this.additionalTracking[i].id === id) {
          this.additionalTracking.splice(i, 1);
        }
      }
    },
    updateRequested(boolean) {
      this.requested = boolean;
    },
    updateProximity(boolean) {
      this.proximity = boolean;
    },
    updateNeeded(boolean) {
      this.needed = boolean;
    }
  },
  computed: {
    ...mapGetters({
      orderDetails: "orderDetails"
    }),
    pageCount() {
      if (this.orderDetails.order_items) {
        return Math.floor(this.orderDetails.order_items.length/3);
      }
      else{
        return 0;
      }
    },
    editValid(){
      return this.requested != null && this.proximity != null && this.needed != null && this.revisedMessage != null && this.addComments != null;
    },
    shippingValid(){
      return this.trackingNumber != "" && this.file != null;
    },
    approver() {
      return this.$store.getters.isApprover;
    },
    status() {
      if(!this.approver){
        return this.orderDetails.order_status;
      }
      else{
        if(this.orderDetails.shipping_status) {
          return this.orderDetails.shipping_status;
        }
      }
      return this.orderDetails.order_status;
    },
  },
  created() {
    this.orderNo = this.$route.params.order;
    if (!this.orderNo) {
      this.$router
        .replace({
          name: "orders"
        })
        .catch(err => {
          this.error = err;
        });
    } else {
      this.getOrderDetails();
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  text-align: left;
  margin-bottom: 10px;
  margin-top: 0px;
}

h2 {
  font-weight: bold;
  font-size: 20px;
  color: #8c8c8c;

  &.approved {
    color: #8c8c8c;
    font-weight: 800;
  }
  &.revised {
    color: #d7566a;
    font-weight: 800;
  }
  margin-top: 0;
  margin-bottom: 10px;
}

h3 {
  font-weight: 900;
  margin: 5px 0;
  font-size: 20px;
  font-family: "Proxima SemiBold";
}

h5 {
  font-size: 14px;
  font-weight: bold;
  margin: 0;
}

p {
  margin: 0;
  font-size: 14px;
  font-family: "Proxima SemiBold";
}

button {
  &.active {
    background: #2266bb;
    color: white;
    cursor: default;
  }
  &.disabled{
    cursor: default;
  }
  &.activeShip{
    background: #2266bb;
    color: white;
    cursor: pointer;
  }
}

.rp-header {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  font-weight: bold;
  padding-top: 30px;
  align-self: normal;
  font-family: "Proxima SemiBold";
}

.button-container {
  padding-bottom: 20px;
}

.button-container-bottom {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

::placeholder {
  color: #c3cfd9;
}

.orderDetails {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.main {
  display: flex;
  height: 100%;
  width: 100%;
}

.title {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.center-panel {
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.center-container {
  margin: 0 64px;
}

.center-header {
  display: flex;
  align-items: flex-start;
  text-align: left;
  flex-direction: column;
  border-bottom: 2px solid #bfbfbf;
  padding-bottom: 5px;
}

.order-container {
  border-bottom: 2px solid #bfbfbf;
  display: flex;
  text-align: left;
  justify-content: space-between;
  padding: 15px 0;
}

.order-left {
  display: flex;
}

.order-right {
  display: flex;
  font-size: 16px;
  font-family: "Proxima SemiBold";
}

.order-img {
  width: 75px;
  height: 75px;
}

.img-container {
  position: relative;
  margin-right: 30px;
}

.info-container {
  margin-right: 200px;
}

.order-large {
  font-size: 16px;
}

.order-small {
  font-size: 14px;
}

.date-container {
  display: flex;
  flex-direction: row;
  margin-top: 12px;
  font-size: 14px;
}

.dates {
  margin: 0;
  font-size: 12px;
}

.date-label {
  padding-right: 20px;
}

.cost {
  margin-right: 100px;
}

.right-panel {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 40px;
  width: 300px;
  padding-top: 30px;
  background-color: #bfbfbf;
}

.rp-container {
  text-align: left;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
}

.rp-container-last {
  text-align: left;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.view-map {
  cursor: pointer;
  color: #2b66bc;
  margin-top: 10px;
  font-weight: bold;
  font-size: 14px;
}

.arrows {
  display: flex;
  align-items: center;
}

.revised-btn {
  margin-right: 0 !important;
}

.upload-container {
  display: flex;
  margin-top: 25px;
  align-items: center;
  position: relative;
}

.file-input {
  height: auto;
  border: none;
  color: #efefef;

  &:focus {
    outline: none;
  }
}

.file-input::-webkit-file-upload-button {
  visibility: hidden;
  width: 0px;
}

.file-input::before {
  content: "UPLOAD RETURN LABEL ZIP FILE OR PDF";
  display: inline-block;
  white-space: nowrap;
  -webkit-user-select: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  color: #2266bb;
  height: auto;
  cursor: pointer;
  background: #efefef;
  padding-top: 3px;
}

.uploaded-file {
  font-size: 14px;
  color: #2266bb;
  font-weight: 600;
  padding-top: 10px;
  text-align: left;
  display: flex;
}

.tracking-inputs {
  display: flex;
  padding-bottom: 20px;
  position: relative;
}

.modal-bg {
  .modal {
    .modal-body {
      overflow: auto !important;
    }
  }
}

.app-modal {
  ::v-deep {
    overflow: auto !important;
  }
}

.modal{
  input{
    width: 96%;
  }
}

.body {
  font-size: 14px;
}

.circle-icon {
  height: 18px;
  position: absolute;
  right: 35px;
  bottom: 34px;
  cursor: pointer;
}

.info-icon {
  width: 18px;
  margin-left: 10px;
  vertical-align: middle;
  cursor: pointer;
}

.boolean-btn-yes {
  width: 60px;
  height: 30px;
  border-radius: 25px 0px 0px 25px;
  cursor: pointer;
  color: #2266bb;
  border: 1px solid #8c8c8c;

  &.active {
    color: white !important;
    background-color: #8c8c8c !important;
  }
}

.boolean-btn-no {
  width: 60px;
  height: 30px;
  border-radius: 0px 25px 25px 0px;
  cursor: pointer !important;
  background: transparent !important;
  color: #2266bb !important;
  border: 1px solid #8c8c8c;

  &.active {
    color: white !important;
    background-color: #8c8c8c !important;
  }
}

.flex-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;
  
  h3{
    margin: 0 !important;
    margin-block: 0;
    margin-inline: 0;
  }
}

.shipped {
  cursor: pointer !important;
}
</style>